//import React from 'react'
//import PortalMessage from 'Components/PortalMessage'
import { defineMessages } from 'react-intl'

const formattedMessage = {}

export const messages = defineMessages({
  termsAgreementText: {
    id: 't.app.terminalsManagement.disputeless.details.termsAgreementText',
    defaultMessage: 'By continuing you declare that you have read and accepted the'
  },
  termsAndConditions: {
    id: 't.app.terminalsManagement.disputeless.details.termsAndConditions',
    defaultMessage: 'terms and conditions'
  },
  termsAndConditionsAriaLabel: {
    id: 't.app.accessibility.terminalsManagement.disputeless.details.termsAndConditions.ariaLabel',
    defaultMessage: 'terms and conditions'
  }
})
export default formattedMessage
